module.exports = __webpack_public_path__ + "images/emoji/last_quarter_moon_with_face.6d5b1043a3d36190b09d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/last_quarter_moon_with_face.png
// module id = oGbz
// module chunks = 14